// ----------------------------------------------------------------------------
// Product Form Extension: Sticky Cart
// ----------------------------------------------------------------------------
// Manages the visibility of a "sticky cart" element based on the user's scroll position.
// ----------------------------------------------------------------------------
// Event Listeners:
// - 'productForm:init' → Listens for the product form initialization event to
//                        initialize the sticky cart classes and observer.
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Toggles visibility classes ('product__sticky--show' and 'product__sticky--hide')
//   on the sticky cart based on the intersection ratio and scroll position.
// ----------------------------------------------------------------------------
// Gotchas:
// - Relies on IntersectionObserver to check visibility, so it requires supported browsers.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// Styles
import './_product-form--sticky.scss';

// -------------------------------------
// Sticky Cart Class
// -------------------------------------

class StickyCart {
  constructor(iamProductForm) {
    this.iamForm = iamProductForm;
    this.initStickyCart();
  }
  initStickyCart() {
    var options = {
      rootMargin: '100px 0px 0px 0px',
      threshold: [0, 0.01, 1]
    };
    var target = this.iamForm.querySelector('#productStickyContainer');
    if (!target) return;
    var observer = new IntersectionObserver(this.showHideStickyCart.bind(this), options);
    observer.observe(target);
  }
  showHideStickyCart(entries) {
    var entry = entries[0];
    if (entry.intersectionRatio >= 1) {
      entry.target.classList.remove('product__sticky--show');
      document.body.classList.remove('has-sticky-cart');
    } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
      entry.target.classList.add('product__sticky--show');
      entry.target.classList.remove('product__sticky--hide');
      document.body.classList.add('has-sticky-cart');
    } else {
      entry.target.classList.add('product__sticky--hide');
      document.body.classList.remove('has-sticky-cart');
    }
  }
}

// -------------------------------------
// Event Listeners
// -------------------------------------

iamotaEventHandler.subscribe('productForm:init', _ref => {
  var {
    iamForm
  } = _ref;
  new StickyCart(iamForm);
}, {
  source: "product-form--sticky.js"
});